import React from 'react';
import { formatNum, formatNumOneDecimal } from '../utils/formatNum';
import { calcGrowthFromValues } from '../utils/calculation';
import moment from 'moment-timezone';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const renderDataIndicator = (isRender: any) => {
  if (isRender) return ' (R)';
  return '';
};

const ForecastInfoCard = ({
  forecastBudgetData,
  currentForecastYear,
}: {
  forecastBudgetData: any;
  currentForecastYear: number;
}) => {
  const casesGrowth = calcGrowthFromValues(
    Number(forecastBudgetData.cases),
    Number(forecastBudgetData.extrapolatedCases || forecastBudgetData.prevcases),
  );
  const revenueGrowth = calcGrowthFromValues(
    Number(forecastBudgetData.revenue),
    Number(forecastBudgetData.extrapolatedRevenue || forecastBudgetData.prevrevenue),
  );

  return (
    <React.Fragment>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{currentForecastYear - 1} Actual Shipments</h4>
              <>
                <h4 className="card-title" style={{ fontSize: '14px' }}>
                  {forecastBudgetData?.extrapolatedCases
                    ? 'Actual (Stnd./ 9L): '
                    : forecastBudgetData?.isForecasted
                      ? 'Forecasted: '
                      : null}
                  <OverlayTrigger
                    placement={'right'}
                    overlay={
                      <Tooltip>
                        Shipments from Parkstreet up until{' '}
                        {moment(forecastBudgetData.endOfYTDYearOne).utc().format('MM/DD/YYYY')}.
                      </Tooltip>
                    }
                  >
                    <span className="px-1 text-muted">
                      <FontAwesomeIcon style={{ fontSize: '14px' }} className="text-primary" icon={faQuestionCircle} />
                    </span>
                  </OverlayTrigger>
                </h4>
                <h4 className="card-title" style={{ fontSize: '14px', marginLeft: '12px' }}>
                  {formatNumOneDecimal(Number(forecastBudgetData.prevcases))} /{' '}
                  {formatNumOneDecimal(Number(forecastBudgetData.prevcases9L))}
                </h4>
              </>
              {forecastBudgetData?.extrapolatedCases ? (
                <>
                  <h4 className="card-title" style={{ fontSize: '14px' }}>
                    Real Time Forecast:{renderDataIndicator(forecastBudgetData.extrapolatedCasesFromRender)}
                    <OverlayTrigger
                      placement={'right'}
                      overlay={<Tooltip>Extrapolated Shipments if the sales continues at current pace.</Tooltip>}
                    >
                      <span className="px-1 text-muted">
                        <FontAwesomeIcon
                          style={{ fontSize: '14px' }}
                          className="text-primary"
                          icon={faQuestionCircle}
                        />
                      </span>
                    </OverlayTrigger>
                  </h4>
                  <h4 className="card-title" style={{ fontSize: '14px', marginLeft: '12px' }}>
                    {formatNumOneDecimal(Number(forecastBudgetData.extrapolatedCases))} /{' '}
                    {formatNumOneDecimal(Number(forecastBudgetData.extrapolatedCases9L))}
                  </h4>
                </>
              ) : null}
              <h6 className="text-muted card-subtitle mb-2"></h6>
              <div className="mb-0">
                <span
                  className={`badge bg-${Number(forecastBudgetData.casesGrowthForPrevYear) >= 0 ? 'primary' : 'danger'} me-2 bg-success`}
                >
                  {formatNum(Number(forecastBudgetData.casesGrowthForPrevYear), 1, 1)}%
                </span>
                <span>Growth over previous year</span>
                <div>As of {moment(forecastBudgetData.endOfYTDYearOne).utc().format('MM/DD/YYYY')}</div>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{currentForecastYear - 1} Actual Revenue</h4>
              <h4 className="card-title" style={{ fontSize: '14px' }}>
                {forecastBudgetData?.extrapolatedRevenue
                  ? 'Actual: '
                  : forecastBudgetData?.isForecasted
                    ? 'Forecasted: '
                    : null}{' '}
                <OverlayTrigger
                  placement={'right'}
                  overlay={
                    <Tooltip>
                      Revenue from Parkstreet up until{' '}
                      {moment(forecastBudgetData.endOfYTDYearOne).utc().format('MM/DD/YYYY')}.
                    </Tooltip>
                  }
                >
                  <span className="px-1 text-muted">
                    <FontAwesomeIcon style={{ fontSize: '14px' }} className="text-primary" icon={faQuestionCircle} />
                  </span>
                </OverlayTrigger>
              </h4>
              <h4 className="card-title" style={{ fontSize: '14px', marginLeft: '12px' }}>
                ${formatNum(Number(forecastBudgetData.prevrevenue))}
              </h4>
              {forecastBudgetData?.extrapolatedRevenue ? (
                <>
                  <h4 className="card-title" style={{ fontSize: '14px' }}>
                    Real Time Forecast{renderDataIndicator(forecastBudgetData.extrapolatedRevenueFromRender)}:
                    <OverlayTrigger
                      placement={'right'}
                      overlay={<Tooltip>Extrapolated revenue if the sales continues at current pace.</Tooltip>}
                    >
                      <span className="px-1 text-muted">
                        <FontAwesomeIcon
                          style={{ fontSize: '14px' }}
                          className="text-primary"
                          icon={faQuestionCircle}
                        />
                      </span>
                    </OverlayTrigger>
                  </h4>
                  <h4 className="card-title" style={{ fontSize: '14px', marginLeft: '12px' }}>
                    ${formatNum(Number(forecastBudgetData.extrapolatedRevenue))}
                  </h4>
                </>
              ) : null}
              <h6 className="text-muted card-subtitle mb-2"></h6>
              <div className="mb-0">
                <span
                  className={`badge bg-${Number(forecastBudgetData.revenueGrowthForPrevYear) >= 0 ? 'primary' : 'danger'} me-2 bg-success`}
                >
                  {formatNum(Number(forecastBudgetData.revenueGrowthForPrevYear), 1, 1)}%
                </span>
                <span>Growth over previous year</span>
                <div>As of {moment(forecastBudgetData.endOfYTDYearOne).utc().format('MM/DD/YYYY')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{currentForecastYear} Projected Shipments</h4>
              <h4 className="card-title" style={{ fontSize: '14px' }}>
                {formatNumOneDecimal(Number(forecastBudgetData.cases))} /{' '}
                {formatNumOneDecimal(Number(forecastBudgetData.cases9L))}(9L)
              </h4>
              {forecastBudgetData?.extrapolatedCases ? (
                <h4 className="card-title text-white" style={{ fontSize: '14px' }}>
                  .
                </h4>
              ) : null}
              <h6 className="text-muted card-subtitle mb-2"></h6>
              <div className="mb-0">
                <span
                  className={`badge bg-${Number(Math.ceil(casesGrowth)) >= 0 ? 'primary' : 'danger'} me-2 bg-success`}
                >
                  {formatNum(casesGrowth === Infinity ? 100 : casesGrowth, 1, 1)}%
                </span>
                <span>Growth over previous year</span>
              </div>
            </div>
          </div>
        </div>
        <div className="col">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{currentForecastYear} Projected Revenue</h4>
              <h4 className="card-title" style={{ fontSize: '14px' }}>
                ${formatNum(Number(forecastBudgetData.revenue))}
              </h4>
              {forecastBudgetData?.extrapolatedRevenue ? (
                <h4 className="card-title text-white" style={{ fontSize: '14px' }}>
                  .
                </h4>
              ) : null}
              <h6 className="text-muted card-subtitle mb-2"></h6>
              <div className="mb-0">
                <span
                  className={`badge bg-${Number(Math.ceil(revenueGrowth)) >= 0 ? 'primary' : 'danger'} me-2 bg-success`}
                >
                  {formatNum(revenueGrowth === Infinity ? 100 : revenueGrowth, 1, 1)}%
                </span>
                <span>Growth over previous year</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ForecastInfoCard;
